/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";
import "./renderErrorMsg.css";

export function renderErrorMsg(errStr) {
  if (!errStr) return null;
  return (
    <div>
      <div className="renderErrorMsg-errorIndicator"></div>
      <div className="renderErrorMsg-errorMessage">{errStr}</div>
    </div>
  );
}
